<template>
  <el-dialog
    :title="title"
    :visible.sync="$store.state.modal.current == 'Payouts Confirmation'"
    :before-close="closeModal">

    
    <template v-if="modal.mode == 'Request Submission'">
      <!-- You are about to request the submission of the following payouts: -->
      <br><br>
      <ul>
        <li>Total pending payouts: {{ nbToRequest }}</li>
        <template v-if="nbExcluded > 0">
          <li>Payouts excluded: {{ nbExcluded }}</li>
          <li><b>Payouts to request submission for:</b> {{ nbToRequest - nbExcluded }}</li>
        </template>
      </ul>

      <span slot="footer" class="dialog-footer">
        <button class="btn" @click="closeModal()">Cancel</button>&nbsp;
        <button class="btn btn-success" @click="submit()" :disabled="(nbToRequest - nbExcluded) < 1">Confirm</button>
      </span>
    </template>

    <template v-else-if="modal.mode == 'Submit'">
      <!-- The following payouts will be submitted for payment: -->
      <br><br>
      <ul>
        <li>Payouts to Submit: {{ nbToSubmit }}</li>
        <template v-if="nbExcluded > 0">
          <li>Payouts excluded: {{ nbExcluded }}</li>
          <li><b>Payouts that will be submitted:</b> {{ nbToSubmit - nbExcluded }}</li>
        </template>
      </ul>

      <span slot="footer" class="dialog-footer">
        <button class="btn" @click="closeModal()">Cancel</button>&nbsp;
        <button class="btn btn-success" @click="submit()" :disabled="(nbToSubmit - nbExcluded) < 1">Confirm</button>
      </span>

    </template>

  </el-dialog>
</template>

<script>
import {Payout} from 'src/classes/datamodel.js'
export default {
  name: 'Payouts-Confirmation-Modal',
  computed: {
    modal () {
      return this.$store.getters.modal
    },
    title () {
      if (!this.modal) {
        return '-'
      }
      switch (this.modal.mode) {
        case 'Request Submission':
          return 'Requesting Payouts to be Submitted for Payment'
          break;
        case 'Submit':
          return 'Submitting Payouts for Payment'
          break;
        default:
          return 'Confirmation needed'
          break;
      } 
    },
    nbToRequest () { // Number of payouts to request
      return this.$store.getters.payouts.filter(p => p.status == Payout._status.PENDING.value
                                                     && !p.archived).length
    },
    nbToSubmit () { // Number of payouts to submit
      return this.$store.getters.payouts.filter(p => p.status == Payout._status.SUBMISSION_REQUESTED.value
                                                     && !p.archived).length
    },
    nbExcluded () { // Number of payouts excluded (= selected via checkbox in a table on the page)
      //console.log('nbExcluded(): ', this.$store.getters.selectedObjects)
      return this.$store.getters.selectedObjects ? this.$store.getters.selectedObjects.length
                                                 : 0
    }
  },
  methods: {
    closeModal () {
      this.$store.dispatch('closeModal')
    },
    async submit() {
      //console.log('savePayout: ', typeof this.payout.amount)
      let submit = (this.modal.mode == 'Submit')
      let payouts = this.$store.getters.payouts.filter(p => p.status == (submit ? Payout._status.SUBMISSION_REQUESTED.value
                                                                                : Payout._status.PENDING.value)
                                                            && !p.archived)
      let selectedObjectsJson = this.$store.getters.selectedObjectsJson
      if (selectedObjectsJson) {
        payouts = payouts.filter(p => !(p.id in selectedObjectsJson))
      }
      const res = await this.$store.dispatch(submit ? 'submitPayoutsForPayment' : 'requestPayoutsSubmission', payouts)
      if (res.errors) {
        if (!res.errors[0].toLowerCase().includes('session')) { // we don't show the error because the API service is rerouting to login page
          this.$notify({ errorMessage: res.errors[0] })
        }
      }
      else { this.$notify({ successMessage: 'Submitted!'})
             this.closeModal()
      }
      this.closeModal()
    }
  }
}
</script>

<style>

</style>